const groupContent = {
  title: '그룹 관리 매뉴얼',
  content: `
  <div class="page-title">[그룹 관리]</div>

# [개요]
그룹 관리는 직원들의 권한을 효율적으로 관리하기 위한 도구입니다. 이 문서에서는 **그룹의 등록, 수정, 조회 등 전반적인 관리 방법**을 확인할 수 있습니다.

### 주요 기능 요약
| 기능 | 설명 | 권한 |
|------|------------------|------------|
| 그룹 조회 | 등록된 그룹 목록 확인 및 검색 | 관리자 |
| 그룹 등록 | 신규 그룹 등록 | 관리자 |
| 그룹 수정 | 기존 그룹 정보 수정 | 관리자 |

# [조회]
등록된 그룹의 목록을 조회하고 관리할 수 있습니다.

### 📋 화면 구성 및 기능
| 영역 | 구성 | 주요 기능 |
|------|------|-----------|
| 목록 영역 | 그룹 목록 테이블 | • 그룹명/설명/사용여부 확인<br>• 더블클릭으로 상세 정보 확인 |
| 검색 영역 | 검색 조건 | • 그룹명 기준 검색 |
| 버튼 영역 | 등록 버튼 | • 신규 그룹 등록 |

![그룹 목록](/assets/images/guide/group/list.png)

# [등록/수정]
그룹을 신규 등록하거나 기존 그룹의 상세 정보를 수정할 수 있습니다.

> ⚠️ **주의사항**
> - 메뉴 또는 직원계정에서 사용 중인 그룹은 삭제할 수 없습니다.
> - 그룹을 삭제하기 전에 연결된 메뉴와 직원계정을 먼저 해제해야 합니다.
> - 저장 즉시 반영됩니다.

### 📋 화면 구성 및 기능
| 영역 | 입력 항목 | 설명 |
|------|-----------|------|
| 기본 정보 | • 그룹명<br>• 설명<br>• 사용 여부 | • 그룹의 이름 입력<br>• 그룹에 대한 설명 입력<br>• 그룹 사용 여부 설정 |

![그룹 등록/수정](/assets/images/guide/group/edit.png)
  `,
};

export default groupContent;
